// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PPoundOutlinedSvg from "@fishx/icons-svg/es/asn/PPoundOutlined";
import FishxIcon from '../components/FishxIcon';

var PPoundOutlined = function PPoundOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PPoundOutlinedSvg
  }));
};

PPoundOutlined.displayName = 'PPoundOutlined';
export default React.forwardRef(PPoundOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PPoundOutlined.js
// module id = 3547
// module chunks = 0